
$(function () {
    $("[stems-calendar] input").each(function (idx, element) {
        var f = $(element).parents("[stems-calendar]").data("date-format");
        var millis = $(element).parents("[stems-calendar]").attr("stems-calendar");
        var gt = $(element).parents("[stems-calendar]").data("greater-than");
        var debug = $(element).parents("[stems-calendar]").data("debug");
        var minDate = $(element).parents("[stems-calendar]").data("min-date");

        var calendar = $(element).datetimepicker({
            format: f,
            debug: debug ? true : false,
            minDate: minDate
        });

        if (millis) {
            calendar.data("DateTimePicker").date(new Date(parseInt(millis)))
        }

        if (gt) {
            //this is related to this issue #1075
            //https://github.com/Eonasdan/bootstrap-datetimepicker/issues/1075
            calendar.data("DateTimePicker").useCurrent(false);

            $("#" + gt).on("dp.change", function (e) {
                $(element).data("DateTimePicker").minDate(e.date);
            });
        }

        $(this).on("dp.change", function (e) {
            //the calendar has been cleared
            if (e.date === false) {
                calendar.data("DateTimePicker").clear();

                if (gt) {
                    $("#" + gt).data("DateTimePicker").maxDate(false);
                }

                $(this).parents("[stems-calendar]").find("input[type=hidden]").val("");
                $(this).parents("[stems-calendar]").trigger(WidgetEvents.CALENDAR_CHANGED, null);
                return;
            }

            if (gt) {
                $("#" + gt).data("DateTimePicker").maxDate(e.date);
            }

            $(this).parents("[stems-calendar]").find("input[type=hidden]").val(e.date.format());
            $(this).parents("[stems-calendar]").trigger(WidgetEvents.CALENDAR_CHANGED, e.date.format());
        })

        $(element).parents("[stems-calendar]").children("a").click(function () {
            calendar.focus();
        });
    });
})